<sbnb-apps-detail-page
  vendorCode="crewdogs"
  name="Crewdogs"
  logoTile="/assets/images/apps/crewdogs.png"
  builtBy="Crewdogs"
  builtByLink="https://crewdogs.com/"
  [categories]="['Channels']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead,
    AppPermission.calendarWrite,
    AppPermission.messageWrite
  ]"
  email="support@crewdogs.com"
  phone="+1 844-815-1776"
  [helpArticles]="[
    {
      id: '11038364',
      title: 'Connect Hospitable with Crewdogs'
    }
  ]">
  <ng-container description>
    <p>
      Gain exclusive access to a community of over 25 million veterans, service members, and family with this seamless
      integration. Let us help you increase occupancy with higher margins, higher peace of mind, and a more purposeful
      experience.
    </p>

    <h3 class="text-xl font-semibold mt-8 mb-4">Why choose Crewdogs for your Hospitable Listings?</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li><strong>Trustworthy travelers:</strong> every guest is verified by industry leading digital partner ID.me</li>
      <li><strong>Short and mid-term stays:</strong> unlock your place for BOTH Vacation and Official Government Travel</li>
      <li><strong>Lower fees:</strong> Offer a military discount without hurting your profits</li>
      <li><strong>Support Veteran causes:</strong> guests donate, hosts can donate, and Crewdogs donates to your foundation of choice with every stay</li>
    </ul>

    <h4 class="font-semibold mt-4 !mb-0">Experience superior customer service with Crewdogs</h4>
    <p>Your home, your hosting experience, we exist to help you host better.</p>
    <sbnb-image-carousel
      class="mt-5"
      [images]="[
        '/assets/images/apps/crewdogs/1.png',
        '/assets/images/apps/crewdogs/2.png',
      ]"></sbnb-image-carousel>
  </ng-container>
</sbnb-apps-detail-page>
